import React from 'react'

const ShowDesignStatistics = ({designDetail}) => {

    return (
        <>
            {designDetail?.variants?.length > 0 &&
                <div className="mt-1 mx-2 text-center">
                    <div
                        className="font-bold text-purple-700 flex justify-center">{designDetail?.variants?.length}</div>
                    <div className="text-sm">Variants</div>
                </div>
            }

            {designDetail?.statistics?.inDesign > 0 &&
                <div className="mt-1 mx-2 text-center">
                    <div
                        className="font-bold text-gray-700 flex justify-center">{designDetail?.statistics?.inDesign}</div>
                    <div className="text-sm">In Design</div>
                </div>
            }

            {designDetail?.statistics?.published > 0 &&
                <div className="mt-1 mx-2 text-center">
                    <div
                        className="font-bold text-purple-700 flex justify-center">{designDetail?.statistics?.published}</div>
                    <div className="text-sm">Published
                    </div>
                </div>
            }

            {designDetail?.statistics?.readyToPublish > 0 &&
                <div className="mt-1 mx-2 text-center">
                    <div
                        className="font-bold text-green-700 flex justify-center">{designDetail?.statistics?.readyToPublish}</div>
                    <div className="text-sm">Ready
                        To Publish
                    </div>
                </div>
            }
        </>
    )
}

export default ShowDesignStatistics
